export const FLOATING_CHAT_LAYER_Z_INDEX = {
  scrollToBottom: 20,
  experienceSurvey: 30,
} as const;
